var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo } from 'react';
import cc from 'classcat';
import './spinner.style.scss';
/**
 * Spinner to show on when loading
 */
var Spinner = function (_a) {
    var className = _a.className, rest = __rest(_a, ["className"]);
    return (React.createElement("div", __assign({ className: cc([className, 'tfm-spinner']) }, rest),
        React.createElement("div", { className: "tfm-spinner-icon" }, Array.from(Array(12).keys()).map(function (i) { return React.createElement("div", { key: i, style: { '--spinner-arms-amount': i } }); }))));
};
export default memo(Spinner);
